<template>
  <v-container v-if="services.length > 0" grid-list-xl pa-0 font-weight-light>
    <v-row wrap>
      <v-col v-for="svc in currentServices" :key="svc.id" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <service-card :to="`/service/${svc.id}`" :title="svc.name" :description="svc.description" :image="svc.image" :color="svc.color" />
      </v-col>
    </v-row>
  </v-container>
  <stub-page v-else header="Услуги не найдены" message="Такой страницы нет. Возможно, она была перемещена или удалена." />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Service',

  computed: {
    ...mapGetters({
      services: 'common/services',
      // isLoggedIn: 'user/isAuthenticated',
      userRoles: 'user/userRoles'
    }),
    // currentServices: function() {
    //   return this.services.filter(srv => srv.group === 'common' && (srv.mode == 'common' || this.userRoles.includes(srv.mode) || this.userRoles.includes('superuser')))
    // }
    currentServices: function() {
      return this.services.filter(srv => 
        srv.group === 'common' && 
        (srv.mode == 'common' || srv.mode == 'legal' || this.userRoles.includes(srv.mode) || this.userRoles.includes('superuser'))
      )
    }
  }
}

</script>
